// @flow
import { useFeatureFlags } from 'src/hooks/useFeatureFlag';

import { DomainBundle } from '../DomainBundle';

import { XsellHosting } from './Xsell/XsellHosting';

import styles from './Offers.scss';

type Props = {
  hasBundle?: boolean,
  showXSell: boolean,
  fqdn: string,
  isLoading: boolean,
};

export function Offers({
  fqdn,
  hasBundle,
  isLoading,
  showXSell,
}: Props): React.MixedElement {
  const { FF_SUGGEST_XSELL } = useFeatureFlags();

  return (
    <>
      {FF_SUGGEST_XSELL && showXSell && (
        <XsellHosting
          className={styles.offer}
          fqdn={fqdn}
          isLoading={isLoading}
        />
      )}
      {hasBundle && <DomainBundle className={styles.offer} />}
    </>
  );
}
